<template>
	<div>
		<div class="card mb-4">
            <div class="card-header">
		    	<div class="d-flex justify-content-between container-fluid">
		            <div class="text-muted fs-19">
		            	<strong>Informações</strong>
		            </div>
			    </div>
		    </div>
		    <div class="card-body">
		    	<div class="container-fluid">
		    		<div class="row">
		    			<div class="col-md-6">
		    				<ul class="list-group">
								<li class="list-group-item d-flex justify-content-between teste">
									<div>
										<strong>#</strong>
									</div>
									<div>
										{{ dados.id }}
									</div>
								</li>
								<li class="list-group-item d-flex justify-content-between">
									<div>
										<strong>Nome</strong>
									</div>
									<div>
										{{ dados.nome }}
									</div>
								</li>
								<li class="list-group-item d-flex justify-content-between">
									<div>
										<strong>Categoria</strong>
									</div>
									<div v-if="dados.categoria">
										{{ dados.categoria.nome }}
									</div>
								</li>
							</ul>
		    			</div>
		    			<div class="col-md-6">
		    				<ul class="list-group">
		    					<li class="list-group-item d-flex justify-content-between">
									<div>
										<strong>Quantidade</strong>
									</div>
									<div>
										{{ dados.quantidade }} {{ dados.medida }}
									</div>
								</li>
		    					<li class="list-group-item d-flex justify-content-between">
									<div>
										<strong>Data</strong>
									</div>
									<div>
										{{ dados.data_br }}
									</div>
								</li>
		    					<li class="list-group-item d-flex justify-content-between">
									<div>
										<strong>Valor</strong>
									</div>
									<div class="text-success">
										{{ dados.valor_br }}
									</div>
								</li>
		    				</ul>
		    			</div>
		    		</div>

		    		<div class="row mt-4" v-if="dados.descricao">
					    <div class="col-md-12">
					    	<div class="text-muted fs-17 mb-2 ml-2">
				            	<strong>Descrição</strong>
				            </div>
					        <ul class="list-group">
								<div class="card-body" v-html="dados.descricao"></div>
							</ul>
					    </div>
					</div>
				</div>
		    </div>
		</div>
	</div>
</template>

<script>
	export default {
		props: ['dados']
	}
</script>
